import groupChatReceived from '../assets/sounds/group_chat_received.mp3';
import joinCallSound from '../assets/sounds/join_call.ogg';
import leaveCallSound from '../assets/sounds/leave_call.ogg';

export const playSound = (
  name: 'join-call' | 'leave-call' | 'group-chat-received',
) => {
  let soundFile: string | null = null;
  switch (name) {
    case 'join-call':
      soundFile = joinCallSound;
      break;
    case 'leave-call':
      soundFile = leaveCallSound;
      break;
    case 'group-chat-received':
      soundFile = groupChatReceived;
      break;
    default:
      return;
  }
  const audio = new Audio(soundFile);
  audio.play().catch(console.error);
};
